<template>
<c-body>
    <header class="toolbar">
      <div class="l-container">
        <div class="toolbar__group">
          <c-level>
            <template slot="left">
              <h1 class="toolbar__title">Statistics</h1>
            </template>
            <template slot="right">
              <a href="#" @click.prevent="onDownloadExcel"><img src="/static/excel.png" border="0" style="height: 24px;width: 24px"/></a>
            </template>
          </c-level>
        </div>
      </div></header>
    <div class="l-container">
  <c-row>
    <c-col>
      <c-panel>
        <c-level>
          <c-level-item>
            <div class="u-text-center">
              <div class="u-text-muted">Documents this month:</div>
              <div class="u-h1">{{r.documents}}</div>
            </div>
          </c-level-item>
        </c-level>
      </c-panel>
    </c-col>
    <c-col>
      <c-panel>
        <c-level>
          <c-level-item>
            <div class="u-text-center">
              <div class="u-text-muted">Pages this month:</div>
              <div class="u-h1">{{r.totalPages}}</div>
            </div>
          </c-level-item>
        </c-level>
      </c-panel>
    </c-col>
  </c-row>
  <c-row>
    <c-col>
      <c-panel>
        <c-level>
          <c-level-item>
            <div class="u-text-center">
              <div class="u-text-muted">Documents last month:</div>
              <div class="u-h1">{{r.documentsLastMonth}}</div>
            </div>
          </c-level-item>
        </c-level>
      </c-panel>
    </c-col>
    <c-col>
      <c-panel>
        <c-level>
          <c-level-item>
            <div class="u-text-center">
              <div class="u-text-muted">Pages last month:</div>
              <div class="u-h1">{{r.totalPagesLastMonth}}</div>
            </div>
          </c-level-item>
        </c-level>
      </c-panel>
    </c-col>
  </c-row>
    </div>
    <UserStatisticsFilter ref="usf"></UserStatisticsFilter>
</c-body>
</template>
<script>
import axios from 'axios'
import { mapState } from 'vuex'
import UserStatisticsFilter from './UserStatisticsFilter'

export default {
  name: 'UserStatistics',

  components: {
    UserStatisticsFilter
  },

  data () {
    return {
      r: {}
    }
  },

  computed: {
    ...mapState('auth', ['clientCode'])
  },

  mounted () {
    this.refreshData()
  },

  methods: {
    refreshData () {
      let url = process.env.API + this.clientCode + '/results/statistics'
      this.getData(url)
    },

    getData (url) {
      axios.get(url).then((response) => {
        this.handleData(response.data)
      }).catch((reason) => {
        console.error('Could not get data')
        console.error(reason)
      })
    },

    handleData (data) {
      this.r = data
    },

    onDownloadExcel () {
      this.$refs.usf.downloadData()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/UserStatistics.vue